import React from 'react';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { connect } from 'react-redux';

import theme from '../theme';
import LayoutContainer from 'ntnu-react/material/LayoutContainer';
import ErrorBoundary from '../components/ErrorBoundary';
import Menu from '../components/Menu';
import Footer from '../components/Footer';

import { getViewer } from '../actions/viewerActions';

import styles from './App.css';

class App extends React.Component {
    componentDidMount() {
        // Fetch viewer in App so it is available in store
        this.props.dispatch(getViewer());
    }

    render() {
        return (
            <MuiThemeProvider muiTheme={theme}>
                <ErrorBoundary>
                    <LayoutContainer className={styles.app}>
                        <Menu router={this.props.router} viewer={this.props.viewer}/>
                        {this.props.children}
                        <Footer/>
                    </LayoutContainer>
                </ErrorBoundary>
            </MuiThemeProvider>
        );
    }
}

App.propTypes = {
    children: PropTypes.element,
    dispatch: PropTypes.func.isRequired,
    router: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        viewer: state.viewer.viewer,
    };
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App.js